import dJSON from 'dirty-json';

const moduleSelector = '.faq-section';

(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove();

      const { data } = dJSON.parse(query.data);
      const faqContainer = query.querySelector('.faq-section__wrapper');
      if (!faqContainer || !data?.length) return;

      data.forEach((item, index) => {
        const isOpen = index === 0;
        faqContainer.insertAdjacentHTML('beforeend', /* html */ `
          <div class="faq-item ${isOpen ? 'faq-item--active' : ''}">
            <div class="faq-item__header" role="button" tabindex="0" aria-expanded="${isOpen}">
              <div class="faq-item__content">
                <span class="faq-item__question">${item.question}</span>
                <div class="faq-item__body">
                  <p class="faq-item__answer">${item.answer}</p>
                </div>
              </div>
              <span class="faq-item__icon"></span>
            </div>
          </div>
        `);
      });

      faqContainer.addEventListener('click', (e) => {
        const header = e.target.closest('.faq-item__header');
        if (!header) return;

        const item = header.closest('.faq-item');
        const isActive = item.classList.contains('faq-item--active');

        faqContainer.querySelectorAll('.faq-item--active').forEach((active) => {
          active.classList.remove('faq-item--active');
          active.querySelector('.faq-item__header').setAttribute('aria-expanded', 'false');
        });

        if (!isActive) {
          item.classList.add('faq-item--active');
          header.setAttribute('aria-expanded', 'true');
        }
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
